type HeadingProps = {
	title: string;
	subtitle?: string;
};

export default function Heading({ title, subtitle }: HeadingProps) {
	return (
		<hgroup>
			<h3>{title}</h3>
			{subtitle && <p className="text-subline">{subtitle}</p>}
		</hgroup>
	);
}
